import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {JWT} from "../../../../constants/local-storage";
import {
  faChevronRight,
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";
import FloorSvgPlanning from "./FloorSvgPlanning";
import { functions } from "../../../../constants/common-functions";

export default function MoveLocationPopup(props) {

  var {
    open,
    mode,
    onClose,
    onConfirm
  } = props;

  var [selectedBuilding, setSelectedBuilding] = useState(null);
  var [selectedFloor, setSelectedFloor] = useState(null);
  var [selectedDesks, setSelectedDesks] = useState([]);
  var [view, setView] = useState('PLAN');
  var floors = ["Floor 1", "Floor 2", "Floor 3"];
  var [desks, setDesks] = useState([]);
  const [floorImage, setFloorImage] = useState("");
  const [selectedDeskIds, setSelectedDeskIds] = useState([]);
  const [loadingDesks, setLoadingDesks] = useState(false);
  
  const [zoneMode, setZoneMode] = useState(false);
  const [zoneName, setZoneName] = useState("");
  
  useEffect(() => {
    
     const token = localStorage.getItem(JWT);
     fetch(`/resolutionsoftwareplatform/dashboard/utilisation/floorplan/image?floorId=1`, {
       headers: {
         Authorization: `Bearer ${token}`,
       },
       credentials: "include"
     })
       .then(res => {
  	
         if (!res.ok) throw new Error("Download failed " + res.status);
  	
         return res.blob();
       })
       .then(blob => {setFloorImage(URL.createObjectURL(blob)); loadDesks();})
       .catch(err => console.error(err));
   }, [selectedFloor]);
   
   const loadDesks = (floorId) => {


     setLoadingDesks(true);

     const url =
       "/resolutionsoftwareplatform/dashboard/utilisation/floorplan/observations" +
       "?surveyId=-1" +
       "&floorId=1";

     functions.getArrayFromAjax(
       url,
       function (rows) {

         rows = rows || [];

         const out = [];
         const seen = {};

         rows.forEach(function (r) {
           if (!r || !r.spaceId || !r.svg) return;

           const key = String(r.spaceId).trim();

           if (!seen[key]) {
             seen[key] = true;
             out.push({
               spaceId: Number(key),
               spaceCode: r.spaceCode,
               svg: r.svg
             });
           }
         });
		
         setDesks(out);
         setLoadingDesks(false);
       },

       function (err) {

         // Ignore false-positive array "errors"
         if (Array.isArray(err)) {
           setLoadingDesks(false);
           return;
         }

         console.error("Error loading desks:", err);
         setLoadingDesks(false);
       }
     );
   };

   function toggleDesk(deskId) {
     setSelectedDeskIds(prev =>
       prev.includes(deskId)
         ? prev.filter(id => id !== deskId)
         : [...prev, deskId]
     );
   }
   
  var styles = {

    backdrop: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.4)",
      zIndex: 2000
    },

    popup: {
      position: "absolute",
      top: "100px",
      left: "5%",
      width: "90%",
      bottom:'20px',
      background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
      display: "flex",
      flexDirection: "column",
      borderRadius: "8px",
      boxShadow: "0 20px 60px rgba(0,0,0,0.3)"
    },

	header: {
	  padding: "20px 24px",
	  background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)",
	  color: "#000",
	  display: "flex",
	  justifyContent: "space-between",
	  alignItems: "center",
	  borderTopLeftRadius: "8px",
	  borderTopRightRadius: "8px"
	},
	
	subTitle: {
	  fontSize: "13px",
	  opacity: 0.85
	},

    closeBtn: {
      fontSize: "18px",
      background: "none",
      border: "none",
      cursor: "pointer",
	  color:'black'
    },

    body: {
      flex: 1,
      display: "flex",
      overflow: "hidden"
    },

    leftPanel: {
      width: "320px",
      borderRight: "1px solid #e6e6e6",
      padding: "16px",
      overflowY: "auto"
    },

    panelTitle: {
      fontWeight: "bold",
      marginBottom: "12px"
    },

    treeItem: {
      padding: "8px",
      cursor: "pointer"
    },

    treeSubItem: {
      padding: "6px 16px",
      cursor: "pointer",
      fontSize: "14px"
    },

	rightPanel: {
	  flex: 1,
	  background: "#f5f6f8",
	  position: "relative",
	  display: "flex",
	  flexDirection: "column",
	  overflow: "hidden",
	  minWidth: 0
	},

    placeholder: {
      padding: "40px",
      textAlign: "center",
      color: "#999"
    },

	floorPlanWrapper: {
	  flex: 1,
	  position: "relative",
	  overflow: "hidden",
	  minWidth: 0,
	  minHeight: 0
	},

    floorPlanPlaceholder: {
      margin: "40px",
      height: "80%",
      border: "2px dashed #ccc",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "#777"
    },

    footer: {
      padding: "16px 24px",
      borderTop: "1px solid #e6e6e6",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },

    footerMeta: {
      fontSize: "12px",
      color: "#666"
    },

    cancelBtn: {
      marginRight: "10px"
    },

    confirmBtn: {
      background: "#1f6fe5",
      color: "#fff",
      border: "none",
      padding: "8px 16px",
      borderRadius: "4px",
      cursor: "pointer"
    },
	
	
	selectedRow: {
	  background: "#eaf2ff",
	  color: "#1f6fe5",
	  fontWeight: 600,
	  borderLeft: "3px solid #1f6fe5"
	},
	
	chevron: {
	  width: "18px",
	  color: "#1f6fe5",
	},

	floorAction: {
	  fontSize: "13px",
	  padding: "6px",
	  cursor: "pointer",
	  borderRadius: "4px"
	},
	
	viewToggle: {
	  width: "300px",
	  display: "flex",
	  border: "1px solid #1f6fe5",
	  borderRadius: "999px",
	  overflow: "hidden",
	  background: "#fff",
	  margin: "14px 14px 10px 14px",
	  flex: "0 0 auto"
	},

	pillButton: {
	  flex: 1,
	  padding: "8px 0",
	  fontSize: "13px",
	  fontWeight: 500,
	  border: "none",
	  background: "transparent",
	  cursor: "pointer",
	  color: "#222"
	},

	pillActive: {
	  flex: 1,
	  padding: "8px 0",
	  fontSize: "13px",
	  fontWeight: 600,
	  border: "none",
	  cursor: "default",
	  background: "linear-gradient(90deg, #1f6fe5, #2a8df7)",
	  color: "#fff"
	},

	
	toggleHover: {
	  background: "#ededed"
	},
	
	floorChevron: {
	  color: "#1f6fe5",
	  marginRight: "6px"
	},

	floorChevronSmall: {
	  color: "#1f6fe5",
	  fontSize: "11px",
	  marginRight: "6px"
	},

	floorRow: {
	  padding: "6px 10px",
	  fontSize: "13px",
	  cursor: "pointer",
	  borderRadius: "4px",
	  display: "flex",
	  alignItems: "center"
	},

	floorCard: {
	  background: "#fff",
	  borderRadius: "6px",
	  padding: "10px",
	  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
	  marginBottom: "6px"
	},

	floorCardTitle: {
	  fontWeight: 600,
	  marginBottom: "8px",
	  display: "flex",
	  alignItems: "center"
	},

	floorActionPill: {
	  display: "flex",
	  alignItems: "center",
	  background: "#f2f2f2",
	  borderRadius: "6px",
	  padding: "6px 10px",
	  fontSize: "13px",
	  cursor: "pointer",
	  marginBottom: "6px"
	},

	actionDot: {
	  width: "8px",
	  height: "8px",
	  borderRadius: "50%",
	  background: "#1f6fe5",
	  marginRight: "8px"
	},
	
	zoneBuilder: {
	  height: "100%",
	  display: "flex",
	  flexDirection: "column",
	  background: "#fff",
	  borderRadius: "6px",
	  boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
	  padding: "14px"
	},

	zoneHeader: {
	  fontWeight: 600,
	  marginBottom: "10px"
	},

	zoneInput: {
	  padding: "8px",
	  borderRadius: "4px",
	  border: "1px solid #ccc",
	  marginBottom: "10px"
	},

	zoneDeskList: {
	  flex: 1,
	  overflowY: "auto"
	},

	zoneDeskChip: {
	  display: "flex",
	  justifyContent: "space-between",
	  alignItems: "center",
	  background: "#f2f2f2",
	  borderRadius: "4px",
	  padding: "6px 10px",
	  marginBottom: "6px",
	  fontSize: "13px"
	},

	zoneRemove: {
	  color: "#d33",
	  cursor: "pointer",
	  fontWeight: 600
	},

	zoneEmpty: {
	  fontSize: "12px",
	  color: "#777",
	  padding: "20px",
	  textAlign: "center"
	},

	zoneDone: {
	  marginTop: "10px",
	  background: "#1f6fe5",
	  color: "#fff",
	  border: "none",
	  padding: "8px",
	  borderRadius: "4px",
	  cursor: "pointer"
	}



  };


  if (!open) {
    return null;
  }

  function handleConfirm() {

    var moveZone = {
      mode: mode,
      building: selectedBuilding,
      floor: selectedFloor,
      deskIds: selectedDesks
    };

    onConfirm(moveZone);
  }
  
  function selectAllDesks(){
	
  };
  
  function openCreateZone(){}
  

  return (
    <div style={styles.backdrop}>

      <div style={styles.popup}>

        {/* HEADER */}
        <div style={styles.header}>
          <div>
            <h2 style={{ margin: 0 }}>
              {mode === "ORIGIN"
                ? "Select Origin Location"
                : "Plan Destination Location"}
            </h2>
            <div style={styles.subTitle}>
              {mode === "ORIGIN"
                ? "Select desks or zones to move"
                : "Plan capacity for incoming move"}
            </div>
          </div>

          <button onClick={onClose} style={styles.closeBtn}>
            ✕
          </button>
        </div>
		

        {/* BODY */}
        <div style={styles.body}>
		

		{/* LEFT PANEL */}
		<div style={styles.leftPanel}>
		  {zoneMode ? (
		    <div style={styles.zoneBuilder}>

		      <div style={styles.zoneHeader}>
		        Create Move Zone
		      </div>

		      <input
		        type="text"
		        placeholder="Zone name…"
		        value={zoneName}
		        onChange={e => setZoneName(e.target.value)}
		        style={styles.zoneInput}
		      />

		      <div style={styles.zoneDeskList}>
		        {selectedDeskIds.length === 0 && (
		          <div style={styles.zoneEmpty}>
		            Select desks on the floor plan
		          </div>
		        )}

		        {selectedDeskIds.map(id => {
		          const desk = desks.find(d => d.spaceId === id);
		          if (!desk) return null;

		          return (
		            <div key={id} style={styles.zoneDeskChip}>
		              <span>{desk.spaceCode}</span>
		              <span
		                style={styles.zoneRemove}
		                onClick={() => toggleDesk(id)}
		              >
		                ✕
		              </span>
		            </div>
		          );
		        })}
		      </div>

		      <button
		        style={styles.zoneDone}
		        onClick={() => setZoneMode(false)}
		        disabled={!zoneName || selectedDeskIds.length === 0}
		      >
		        Done
		      </button>

		    </div>
		  ) : (
		    /* 👇 WRAPPED ELSE CONTENT */
		    <div>

		      <div style={styles.panelTitle}>Buildings</div>

		      <div
		        style={styles.treeItem}
		        onClick={() => setSelectedBuilding(!selectedBuilding)}
		      >
		        <span style={{ width: "18px", display: "inline-block" }}>
		          <FontAwesomeIcon
		            icon={selectedBuilding ? faChevronDown : faChevronRight}
		            size="sm"
		          />
		        </span>

		        <span style={{ fontWeight: 500 }}>
		          HQ Building
		        </span>
		      </div>

		      {/* FLOORS */}
		      {selectedBuilding && (
		        <div style={{ marginLeft: "18px" }}>
		          {floors.map(function (floor) {

		            var isSelected = selectedFloor === floor;

		            if (isSelected) {
		              return (
		                <div key={floor} style={styles.floorCard}>

		                  <div style={styles.floorCardTitle}>
		                    <FontAwesomeIcon
		                      icon={faChevronDown}
		                      style={styles.floorChevron}
		                    />
		                    {floor}
		                  </div>

		                  <div
		                    style={styles.floorActionPill}
		                    onClick={selectAllDesks}
		                  >
		                    <span style={styles.actionDot} />
		                    All desks
		                  </div>

						  <div
						    style={styles.floorActionPill}
						    onClick={() => {
						      setZoneMode(true);
						      setZoneName("");
						      setSelectedDeskIds([]);
						    }}
						  >
						    <span style={styles.actionDot} />
						    Create Move Zone
						  </div>

		                </div>
		              );
		            }

		            return (
		              <div
		                key={floor}
		                style={styles.floorRow}
		                onClick={() => setSelectedFloor(floor)}
		              >
		                <FontAwesomeIcon
		                  icon={faChevronRight}
		                  style={styles.floorChevronSmall}
		                />
		                {floor}
		              </div>
		            );
		          })}
		        </div>
		      )}

		    </div>
		  )}
		</div>


		


          {/* RIGHT PANEL */}
          <div style={styles.rightPanel}>
		  <div style={styles.viewToggle}>
		    <button
		      style={view === "PLAN" ? styles.pillActive : styles.pillButton}
		      onClick={() => setView("PLAN")}
		    >
		      Floor Plan
		    </button>

		    <button
		      style={view === "LIST" ? styles.pillActive : styles.pillButton}
		      onClick={() => setView("LIST")}
		    >
		      Desk List
		    </button>
		  </div>
            {!selectedFloor && (
              <div style={styles.placeholder}>
                Select a floor to view plan
              </div>
            )}

            {selectedFloor && (
              <div style={styles.floorPlanWrapper}>
                {/* DROP SVG FLOOR PLAN HERE */}
				{floorImage && desks.length > 0 && (
				  <FloorSvgPlanning
				    desks={desks}
				    floorImage={floorImage}
				    selectedDeskIds={selectedDeskIds}
				    setSelectedDeskIds={setSelectedDeskIds}
				  />
				)}

				{(!floorImage || desks.length === 0) && (
				  <div style={styles.floorPlanPlaceholder}>
				    Loading floor plan…
				  </div>
				)}
              </div>
            )}

          </div>
        </div>

        {/* FOOTER */}
        <div style={styles.footer}>
          <div>
            <strong>
              {selectedBuilding || "No building"}{" "}
              {selectedFloor ? "– " + selectedFloor : ""}
            </strong>
            <div style={styles.footerMeta}>
              Desks selected: {selectedDesks.length}
            </div>
          </div>

          <div>
            <button onClick={onClose} style={styles.cancelBtn}>
              Cancel
            </button>

            <button
              onClick={handleConfirm}
              style={styles.confirmBtn}
              disabled={!selectedFloor}
            >
              Confirm Move Zone
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
